export enum EMeetingDuration {
  '15 mins' = '00:15:00',
  '30 mins' = '00:30:00',
  '60 mins' = '01:00:00',
}
